import React from 'react';

export default () => (
	<div className='Mid1'>
		<h4>If you can dream it, we can build it.</h4>

	</div>
);
